export enum AccessListTypeEnum {
  IP,
  CIDR,
  ASN,
  Country,
  Organization,
  JA4,
}
